// Based on "Tailwind / Alpine Tag Mutli Select"
// https://codepen.io/atomgiant/pen/QWjWgKz

const tagSeparators = [",", ";"];
const disallowedChars = ["@", "!"];

// Create regex for spliting tag strings
const splitRegex = new RegExp(tagSeparators.join("|"), "g");
const disallowedCharsRegex = new RegExp(disallowedChars.join("|"), "g");

const tagsEditor = () => ({
  open: false,
  textInput: "",
  init() {
    if (this.tags) {
      this.tags = this.tags.split(";");
    } else {
      this.tags = [];
    }
  },
  addTag(newTag) {
    const tag = newTag.trim();
    if (tag !== "" && !this.hasTag(tag)) {
      this.tags.push(tag);
    }
    this.clearSearch();
    this.$refs.textInput.focus();
    this.fireTagsUpdateEvent();
  },
  fireTagsUpdateEvent() {
    this.$el.dispatchEvent(
      new CustomEvent("tags-update", {
        detail: {
          tags: this.tags,
          bubbles: true,
        },
      }),
    );
  },
  hasTag(checkTag) {
    const tag = this.tags.find(
      (e) => e.toLowerCase() === checkTag.toLowerCase(),
    );
    return tag !== undefined;
  },
  removeTag(index) {
    this.tags.splice(index, 1);
    this.fireTagsUpdateEvent();
  },
  search(q) {
    // Prevent disallowed characters like @, ! from being used
    if (disallowedChars.some((char) => q.includes(char))) {
      this.textInput = q.replace(disallowedCharsRegex, "");
      return;
    }

    // Limit tag to maximum of 50 characters
    if (q.length > 50) {
      this.textInput = q.substring(0, 50);
    }

    // Split and add tag if comma or semicolon is typed
    if (tagSeparators.some((separator) => q.includes(separator))) {
      q.split(splitRegex).forEach((val) => {
        this.addTag(val);
      }, this);
    }
    this.toggleSearch();
  },
  clearSearch() {
    this.textInput = "";
    this.toggleSearch();
  },
  toggleSearch() {
    this.open = this.textInput !== "";
  },
});

window.tagsEditor = tagsEditor;
